
































import { Component, Prop, Vue, Mixins, Emit } from 'vue-property-decorator';
import { NotificationStoreHelper } from '../../core/mixins';
import Button from '../../core/components/Button.vue';
import { activeFormatter, booleanFormatter, formatDate, getIndexFromList } from '../../core/utils';



@Component({
  components: {
    Button
  }
})
export default class ButtonShowCalibrationsZafra extends Mixins(NotificationStoreHelper) {
  @Prop({ default: null}) calibrations: object | null;  
  @Prop({ default(){return []}}) vehiclesList: Array<object>  


    get getTooltipForCalibrations(){
        let tooltip = '';
        //calibrations = {
        //   vehicle_id_1:[
          //     {
          //       datetime_from: '2021-01-01 00:00:00',
          //       datetime_to: '2021-01-01 00:00:00',
          //     },
          // ],
          // vehicle_id_2:[
          //     datetime_from: '2021-01-01 00:00:00',
          //     datetime_to: '2021-01-01 00:00:00',
          //   }
          // ]
        // }
        if(this.calibrations != null){
            tooltip = '<b>Pasadas de calibracion:</b><br>';
            for (const [vehicle_id, vehicle_calibrations] of Object.entries(this.calibrations)) {
                let vehicleName = vehicle_id;
                let indexInVehicleList = getIndexFromList(this.vehiclesList, 'id', vehicle_id);
                if(indexInVehicleList != -1){
                    vehicleName = this.vehiclesList[indexInVehicleList]['description'];
                }

                tooltip += `<b>${vehicleName}</b><br>`;
                // console.log("vehicle_calibrations", vehicle_calibrations);
                if(Array.isArray(vehicle_calibrations)){

                    vehicle_calibrations.forEach((calibration: any) => {
                        let isActive = calibration.active;
                        let activeText = activeFormatter(isActive);
                        let datetime_from = formatDate(calibration.datetime_from, true);
                        let datetime_to = formatDate(calibration.datetime_to, true);

                        tooltip += `<li>${datetime_from} -  ${datetime_to} (${activeText})</li>`;
                    });
                }
                tooltip += '<br>';
            }
            
        }
        return tooltip
    }


}

